const hotelsActivePrimeSites = [
  'AU',
  'CA',
  'CH',
  'CL',
  'CO',
  'DE',
  'ES',
  'FR',
  'GB',
  'GOFR',
  'GR',
  'IT',
  'KR',
  'MX',
  'NL',
  'NZ',
  'OPAT',
  'OPAU',
  'OPCH',
  'OPDE',
  'OPDK2',
  'OPES',
  'OPFR',
  'OPGB',
  'OPIT',
  'OPNL',
  'OPPL2',
  'OPPT',
  'OPUK',
  'PH',
  'PT',
  'RO',
  'SG',
  'TH',
  'TRDK',
  'TRFI',
  'TRGB',
  'TRNO',
  'UK',
  'US',
  'ZA',
] as const;

export default hotelsActivePrimeSites;
